<template>
    <v-container class="py-6">
        <v-card class="mx-auto pa-6" max-width="700" elevation="4">
            <v-img max-height="150" max-width="200" src="./Bilgros.png" class="mx-auto"></v-img>

            <!-- Titre -->
            <h2 class="text-h5 font-weight-bold mb-4">Suppression de compte Bilgros</h2>

            <!-- Explication -->
            <p class="text-body-1 mb-6">
                Si vous souhaitez supprimer votre compte, veuillez renseigner votre numéro de téléphone ci-dessous.
                Notre équipe traitera votre demande dans un délai raisonnable conformément à notre politique de
                confidentialité.
            </p>

            <!-- Formulaire -->
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field v-model="phoneNumber" label="Numéro de téléphone" type="tel" variant="outlined"
                    prepend-icon="mdi-phone" :rules="[v => !!v || 'Le numéro de téléphone est requis']"
                    required></v-text-field>

                <v-textarea id="Comment" v-model="reason" label="Raison de la suppression (optionnel)"
                    variant="outlined" rows="3" prepend-icon="mdi-comment"></v-textarea>

                <!-- Bouton -->
                <v-btn color="error" class="mt-4" :disabled="!valid" @click="submitRequest">
                    Demander la suppression
                </v-btn>
            </v-form>
        </v-card>
    </v-container>
</template>

<script setup>
import { ref } from 'vue'

const valid = ref(false)
const phoneNumber = ref('')
const reason = ref('')

const submitRequest = () => {
    if (phoneNumber.value) {
        alert(`Demande envoyée avec succès.\nNuméro: ${phoneNumber.value}\nRaison: ${reason.value || 'Non précisée'}`)
    }
}
</script>
